import { useEffect, useState } from "react";

export const EASE = [0.22, 1, 0.36, 1];
export const DUR = { fast: 0.16, std: 0.32, slow: 0.7, cine: 1.2 };

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE, delay: i * 0.08 } }),
};

export const fade = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.9, ease: EASE } },
};

export const maskUp = {
  hidden: { y: "110%" },
  show: (i = 0) => ({ y: "0%", transition: { duration: 0.9, ease: EASE, delay: 0.08 * i } }),
};

export const viewport = { once: true, margin: "-12% 0px" };

export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false,
  );
  useEffect(() => {
    const m = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    setMatches(m.matches);
    m.addEventListener("change", handler);
    return () => m.removeEventListener("change", handler);
  }, [query]);
  return matches;
};

export const useIsDesktop = () => useMediaQuery("(min-width: 1024px)");
export const useFinePointer = () => useMediaQuery("(pointer: fine)");
